import React from "react";
import styles from "./Fire.module.css";
import useFireSmoke from "./useFireSmoke.js";
import Embers from "./Embers.jsx";

/**
 * <Fire/> reutilizável — use em qualquer parte do app.
 *
 * Variantes guardadas:
 *   "classico" (#1 Clássico Alt)
 *   "espiral"  (#2 Espiral Fixo)
 *   "vortice"  (#3 Vórtice Sutil)
 *   "vela"     (#7 Vela)
 *   "agited"  (#6 Agited Suave)
 *
 * Props:
 *   variant: string  — uma das chaves acima
 *   lit:     boolean — true = aceso (loop); false = apagado (com fumaça)
 *   size:    number  — escala (1 = padrão)
 */
const VARIANTS = {
  classico: "vClassico",
  espiral: "vEspiral",
  vortice: "vVortice",
  vela: "vVela",
  agited: "vAgited",
};

export default function Fire({ variant = "classico", lit = true, size = 1, className = "" }) {
  const v = styles[VARIANTS[variant] || VARIANTS.classico];
  const smkRef = useFireSmoke(styles, !lit);

  const cls = [styles.fc, v, lit ? styles.lit : "", className].filter(Boolean).join(" ");

  return (
    <div className={cls} style={{ "--fire-scale": size }}>
      <div className={styles.stage}>
        <div className={styles.glow} />
        <div className={styles.smk} ref={smkRef} />
        <div className={styles.fw}>
          <div className={`${styles.fl} ${styles.or}`} />
          <div className={`${styles.fl} ${styles.gd}`} />
          <div className={`${styles.fl} ${styles.wh}`} />
        </div>
        <Embers />
      </div>
    </div>
  );
}